import { initialValuesParent } from 'civil-status/constants/initial-values-step';
import { ParentVM } from 'civil-status/view-models/step-form';

export const clearSubject = (valuesCurrent: ParentVM): ParentVM => {
  // elimina i dati necessari per il colloquio con il BE
  // utilizzare per controlli momentanei
  return {
    codeSubject: valuesCurrent.codeSubject,
    configuration: valuesCurrent.configuration,
    flagComparente: valuesCurrent.flagComparente,
    flagDichiarante: valuesCurrent.flagDichiarante,
    tipoSoggetto: valuesCurrent.tipoSoggetto,
    flagFirmatario: valuesCurrent.flagFirmatario,
    isSaved: false,
    presenza: valuesCurrent.presenza,
    searchPerson: undefined,
    generality: {
      ...initialValuesParent.generality,
    },
  };
};

export const clearSubjectMomentary = (valuesCurrent: ParentVM): ParentVM => {
  // elimina i dati necessari per il colloquio con il BE
  // utilizzare per controlli momentanei
  return {
    codeSubject: undefined,
    configuration: undefined,
    flagComparente: undefined,
    flagDichiarante: undefined,
    flagFirmatario: undefined,
    tipoSoggetto: undefined,
    isFromSearchPerson: undefined,
    isSaved: undefined,
    presenza: undefined,
    searchPerson: undefined,
    eventType: undefined,
    generality: {
      ...(valuesCurrent?.generality || {}),
      idSubject: undefined,
      conditionsItem: undefined,
      conditionsItemSignatory: undefined,
      typeResidence: undefined,
      typeAct: undefined,
      isBookTwins: undefined,
    },
  };
};
